import { BarChart } from '@mui/x-charts'
import { Box } from '@mui/material'
import { nullSafeValueFormatter } from 'src/v3/utilities/charts'
import { LearnerCountsResponse } from '../scribe.slice'

interface LearnerCountsChartProps {
  data: LearnerCountsResponse
  course?: any
}

export default function LearnerCountsChart({
  data,
  course,
}: LearnerCountsChartProps) {
  if (!data || data.length === 0) {
    let isLiveCourse = course?.kind === 'Live'

    return (
      <Box
        sx={{
          height: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'text.secondary',
        }}
      >
        {isLiveCourse
          ? 'Analytics and Sentiment analysis is coming soon for live courses'
          : 'No learner data available'}
      </Box>
    )
  }

  // Sort data chronologically (most recent first)
  // eslint-disable-next-line fp/no-mutating-methods
  let sortedData = [...data].reverse()

  return (
    <Box sx={{ height: '400px', width: '100%' }}>
      <BarChart
        margin={{ left: 60, right: 40, top: 40, bottom: 120 }}
        dataset={sortedData as any}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'month',
          },
        ]}
        series={[
          {
            dataKey: 'nurse',
            label: 'Nurses',
            valueFormatter: nullSafeValueFormatter,
          },
          {
            dataKey: 'paramedic',
            label: 'Paramedics',
            valueFormatter: nullSafeValueFormatter,
          },
          {
            dataKey: 'emt',
            label: 'EMTs',
            valueFormatter: nullSafeValueFormatter,
          },
          {
            dataKey: 'aemt',
            label: 'AEMTs',
            valueFormatter: nullSafeValueFormatter,
          },
          {
            dataKey: 'other',
            label: 'Others',
            valueFormatter: nullSafeValueFormatter,
          },
        ]}
        slotProps={{
          legend: {
            direction: 'row' as any,
            position: { vertical: 'bottom', horizontal: 'center' },
            sx: { padding: 20 },
          },
        }}
      />
    </Box>
  )
}
